import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import FullScreenIcon from '@material-ui/icons/Fullscreen'
import FullScreenExitIcon from '@material-ui/icons/FullscreenExit'
import NGLContext from '../NGLContext'
import MenuIcon from '@material-ui/icons/Menu'
import NGLSettingsMenu from "./NGLSettingsMenu/NGLSettingsMenu";


const styles = theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    toolbar: {
        justifyContent: 'space-between',
    },
    menuButton: {
        marginInline: '1em',
        outline: 'none !important',
        margin: '0.25em',
    },
});


@withStyles(styles)
class NGLAppBar extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    state = {};

    render() {
        const {classes} = this.props;

        return (
            <NGLContext.Consumer>
                {(contextNGL) => (
                    <React.Fragment>
                        <AppBar position="static" color="inherit"
                                elevation={0}
                                className={classes.appBar}>
                            <Toolbar variant="dense"
                                     disableGutters={true}
                                     className={classes.toolbar}>
                                <div>
                                    <IconButton
                                        className={classes.menuButton}
                                        onClick={contextNGL.handleDrawer}
                                        color="inherit"
                                        aria-label="Menu">
                                        <MenuIcon/>
                                    </IconButton>
                                    <NGLSettingsMenu stage={contextNGL.stage}/>
                                </div>
                                <Typography variant="h6"
                                            color="textSecondary">
                                    NGL Viewer
                                </Typography>
                                <div>
                                    <IconButton
                                        className={classes.menuButton}
                                        color="inherit"
                                        onClick={contextNGL.handleCollapse}
                                        aria-label="Menu">
                                        <FullScreenExitIcon/>
                                    </IconButton>
                                    <IconButton
                                        className={classes.menuButton}
                                        color="inherit"
                                        onClick={contextNGL.handleFullScreen}
                                        aria-label="Menu">
                                        <FullScreenIcon/>
                                    </IconButton>
                                </div>
                            </Toolbar>
                        </AppBar>
                    </React.Fragment>
                )}
            </NGLContext.Consumer>
        );
    }
}

export default NGLAppBar;